import RewardBundlingBanner from './RewardBundlingBanner.f';

export default RewardBundlingBanner;
